// Telefonnummern werden einheitlich im internationalen Format gespeichert:
// "+" + Ländervorwahl + Nummer ohne führende 0, z.B. "+41791234567".

const DIAL_CODES = ["41", "43", "49"];

export function toE164(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  return digits ? `+${digits}` : "";
}

// Anzeige: CH "+41 79 123 45 67", AT/DE "+43 676 6930130".
export function formatPhone(value) {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) return "";

  const dial = DIAL_CODES.find((code) => digits.startsWith(code));
  if (!dial) return `+${digits}`;

  const rest = digits.slice(dial.length);
  if (dial !== "41") {
    return [`+${dial}`, rest.slice(0, 3), rest.slice(3)].filter(Boolean).join(" ");
  }

  // Schweiz: Vorwahl, dann 2 + 3 Ziffern, danach Zweiergruppen
  const parts = [`+${dial}`, rest.slice(0, 2), rest.slice(2, 5)];
  for (let i = 5; i < rest.length; i += 2) parts.push(rest.slice(i, i + 2));
  return parts.filter(Boolean).join(" ");
}
